import { createContext } from "react";
import { User } from "../../interfaces/user";

interface ContextProps {
    isLoggedIn: boolean;
    user?: User;
}

export const AuthContext = createContext({} as ContextProps);
